import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'

import { approveElement } from '../api'
import { contentKeys } from '../queryKeys'

const useApproveSingleVariantMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(approveElement, {
    onError: () => {
      errorToast('Failed to approve variant. Please try again.')
    },
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
      successToast('Variant approved successfully')

      queryClient.invalidateQueries(contentKeys.content(content._id))
      // Invalidate live variants query to reflect changes in the live variants list
      queryClient.invalidateQueries(['personalization-live-variants'])
    },
  })
}

export default useApproveSingleVariantMutation
